module.exports = __webpack_public_path__ + "img/u17762.6b4d56eb.svg";